import Vue from 'vue'
import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'

if (__config) {
  const sentryConfig = __config.sentry

  if (sentryConfig.enabled) {
    Sentry.init({
      dsn: sentryConfig.dsn,
      logErrors: sentryConfig.logErrors,
      integrations: [new Integrations.Vue({
        Vue, attachProps: true
      })]
    })
  }
}
